import { render } from "./App.vue?vue&type=template&id=bc332a0a&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=bc332a0a&lang=css"

import exportComponent from "/home/runner/work/islander-vue-web/islander-vue-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__